var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvaEmailOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 5.5H6.875C5.78098 5.5 4.73177 5.9346 3.95818 6.70818C3.1846 7.48177 2.75 8.53098 2.75 9.625V23.375C2.75 24.469 3.1846 25.5182 3.95818 26.2918C4.73177 27.0654 5.78098 27.5 6.875 27.5H26.125C27.219 27.5 28.2682 27.0654 29.0418 26.2918C29.8154 25.5182 30.25 24.469 30.25 23.375V9.625C30.25 8.53098 29.8154 7.48177 29.0418 6.70818C28.2682 5.9346 27.219 5.5 26.125 5.5ZM25.2038 8.25L16.5 14.7812L7.79625 8.25H25.2038ZM26.125 24.75H6.875C6.51033 24.75 6.16059 24.6051 5.90273 24.3473C5.64487 24.0894 5.5 23.7397 5.5 23.375V9.96875L15.675 17.6C15.913 17.7785 16.2025 17.875 16.5 17.875C16.7975 17.875 17.087 17.7785 17.325 17.6L27.5 9.96875V23.375C27.5 23.7397 27.3551 24.0894 27.0973 24.3473C26.8394 24.6051 26.4897 24.75 26.125 24.75Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaEmailOutline);
export default __webpack_public_path__ + "static/media/eva_email-outline.cb4a0c93cf88a7d4b4da69801329ea91.svg";
export { ForwardRef as ReactComponent };